export default {
    probeunit: {
        unit:'单位',
        unitMark:'单位标记',
        unitMeasurement:'计量单位',
        uOMAlreadyExists:'计量单位已存在',
        unitTagAlreadyExists:'单位标记已存在',
        unitNumber:'单位编号',
        unitNumberAlreadyExists:'单位编号已存在',
        describe:'描述',
        operation:"操作",
        uOMCannotBeBlank:'计量单位不能为空',
        unitCannotBeBlank:'单位标记不能为空',
        unitNumberCannotBeBlank:'单位编号不能为空',
        table_unit_mark: '单位标记',
        table_unit_number: '单位编号',
    }
}